import { WorkItem, WorkItemAction } from "./WorkItem"

export enum RootRouteContentType {
	Dashboard = 'dashboard',
	Form = 'form',
}

export interface RootRouteDashboardContent {
	type: RootRouteContentType.Dashboard
}

export interface RootRouteFormContent {
	type: RootRouteContentType.Form
	renderInstanceId: string
	encounterGuid: string
	action: WorkItemAction
	workItem?: WorkItem
	skipLocationCheck?: boolean
	// optional: restrict view to only one page of the form
	onlyPageIdx?: number
	// opened from an /encounter/{guid} link: see linkedEncounterWriteMode
	openedFromLink?: boolean
}
